<!--Rossmann ActivationSummaryWrapper-->
<!--Lidl ActivationSummaryWrapper-->
<!--Fyve ActivationSummaryWrapper-->
<!--Bildmobil ActivationSummaryWrapper-->
<template>
  <b-row class="app-stepper">
    <b-overlay v-if="showPrev" class="btn-prev-overlay" :show="loadingPrev" spinner-small>
      <b-button @click="$emit('prev')" class="btn-prev" type="button" variant="secondary" :disabled="disabledPrev">
        <slot name="btnPrev">zurück</slot>
      </b-button>
    </b-overlay>
    <slot name="betweenPrevNextButtons"></slot>
    <b-overlay v-if="showNext" class="btn-next-overlay" :show="loadingNext" spinner-small>
      <b-button @click="$emit('next')" class="btn-next" type="button" variant="primary" :disabled="disabledNext">
        <slot name="btnNext">weiter</slot>
      </b-button>
    </b-overlay>
  </b-row>
</template>

<script>
import { BOverlay, BRow, BButton } from 'bootstrap-vue'

export default {
  name: 'Stepper',
  components: {
    BRow, BOverlay, BButton
  },
  props: {
    loadingPrev: {
      type: Boolean,
      default: false
    },
    loadingNext: {
      type: Boolean,
      default: false
    },
    disabledPrev: {
      type: Boolean,
      default: false
    },
    disabledNext: {
      type: Boolean,
      default: false
    },
    showPrev: {
      type: Boolean,
      default: true
    },
    showNext: {
      type: Boolean,
      default: true
    }
  }
}
</script>
